import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string } from 'prop-types';
import { Container, InfoContainer, BrandFigure, InfoText, FigureContainer } from './cardan-car-info.styles';

const CardanCarInfo = _ref => {
  let {
    text,
    alt,
    imageUrl
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["text", "alt", "imageUrl"]);

  return /*#__PURE__*/React.createElement(Container, _extends({
    "data-testid": "car-info-container"
  }, props), /*#__PURE__*/React.createElement(FigureContainer, {
    "data-testid": "info-figure-container"
  }, /*#__PURE__*/React.createElement(BrandFigure, {
    src: imageUrl,
    alt: alt,
    width: 64,
    height: 64,
    lazy: true
  })), /*#__PURE__*/React.createElement(InfoContainer, {
    "data-testid": "info-container"
  }, /*#__PURE__*/React.createElement(InfoText, {
    "data-testid": "info-text"
  }, text)));
};

process.env.NODE_ENV !== "production" ? CardanCarInfo.propTypes = {
  text: string,
  alt: string,
  imageUrl: string
} : void 0;
CardanCarInfo.defaultProps = {
  text: '',
  imageUrl: undefined,
  alt: ''
};
export default CardanCarInfo;